import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { zIndex } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const progressBar = style({
  position: 'fixed',
  height: 4,
  top: 0,
  right: 0,
  left: 0,
  zIndex: zIndex.max,
  transition: 'all 0.8s ease-in-out',
  backgroundColor: themeVars.progress.foreground.default,
  selectors: {
    '&.hidden': {
      transition: 'none',
      transform: 'translateX(-100%)',
    },
    '&.submitting': {
      transform: 'translateX(-50%)',
    },
    '&.loading': {
      transform: 'translateX(-25%)',
    },
    '&.completed': {
      transitionDuration: '0.2s',
      transform: 'translateX(0)',
    },
  },
});
